import { axiosGetAuthorize, axiosPost, axiosPostAuthorize } from '../AxiosRequests';
import { AddEditAnnouncementDetail ,GetAnnouncementDetailList,DeleteAnnouncementDetails,ActiveInActiveAnnouncement,GetAnnouncementDetailById} from '../ApiEndPoints';

export default class AnnouncementServices {

  
    async addEditAnnouncementDetail(request) {
        return axiosPostAuthorize(AddEditAnnouncementDetail, request);
    }

    async getAnnouncementList(request) {
        return axiosPostAuthorize(GetAnnouncementDetailList, request);
    }

    async deleteAnnouncementDetails(request) {
        return axiosPostAuthorize(DeleteAnnouncementDetails, request);
    }
    async activeInActiveAnnouncement(request) {
        return axiosPostAuthorize(ActiveInActiveAnnouncement, request);
    }

    async GetAnnouncementDetailById(request) {
        return axiosGetAuthorize(GetAnnouncementDetailById, request);
    }
}